import { Controller } from "@hotwired/stimulus";

// Switches between tab panels. The URL hash names the open tab, so links and
// redirects such as ".../questions/settings#search-volumes" land on it.
export default class extends Controller {
  static targets = ["tab", "panel"];

  connect() {
    const fromHash = this.nameFromHash();
    this.show(fromHash || this.panelTargets[0]?.dataset.tabsName);
    // The browser jumps to the element named by the hash, below the tab bar;
    // bring the tab bar into view instead, once that jump is done.
    if (fromHash) requestAnimationFrame(() => this.scrollToTabs());

    this.onHashChange = () => {
      const name = this.nameFromHash();
      if (name) this.show(name);
    };
    window.addEventListener("hashchange", this.onHashChange);
  }

  disconnect() {
    window.removeEventListener("hashchange", this.onHashChange);
  }

  select(event) {
    event.preventDefault();
    const name = event.currentTarget.dataset.tabsName;
    this.show(name);
    history.replaceState(null, "", `#${name}`);
  }

  show(name) {
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.tabsName === name;
      tab.classList.toggle("tab-active", active);
      tab.setAttribute("aria-selected", active);
    });
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.tabsName !== name;
    });
  }

  // Leaves room for the fixed page header.
  scrollToTabs() {
    const top = this.element.getBoundingClientRect().top + window.scrollY - 96;
    window.scrollTo({ top: Math.max(top, 0) });
  }

  nameFromHash() {
    const name = decodeURIComponent(window.location.hash.slice(1));
    return this.panelTargets.some((panel) => panel.dataset.tabsName === name) ? name : null;
  }
}
